import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import api from '../../services/api';
import QuoteSection from '../../components/Home/QuoteSection';
import Testimonials from '../../components/Home/Testimonials';
import TeamMember from '../../components/Home/TeamMember';
import Newsletter from '../../pages/PrivacyPolicy/Newsletter';
import { Helmet } from 'react-helmet';
import BlogSection from '../../components/Home/BlogSection';
import UserTypes from '../../components/Home/UserTypes';
import SliderHome from '../../components/Home/SliderHome';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';

const Home = () => {

  const [videos, setVideos] = useState([]);
  const [testimonial] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [slides, setSlides] = useState([]);
  const [homeContent, setHomeContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [homeRes, videosRes, blogsRes, slidesRes] = await Promise.all([
          api.get('/home'),
  
          api.get('/videos'),
       
          api.get('/blog?limit=3'),
       api.get('/banners'),
      
        ]);

        setHomeContent(homeRes.data.data);
        setSlides(slidesRes.data);

        setVideos(videosRes.data);

        setBlogs(blogsRes.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };
    
    fetchData();
  }, []);

if (loading) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center", // horizontal center
        alignItems: "center",     // vertical center
        height: "100vh",          // full viewport height
        width: "100%",            // full width
        backgroundColor: "#fff",  // optional
      }}
    >
      <img
        src="http://localhost:3000/static/media/logo.25b2a68e446a05e3a861.webp"
        alt="Loading..."
      />
    </div>
  );
}


  if (!homeContent) {
    return <div>Error loading home content</div>;
  }

 
  return (
    <div className="home-page">
      {/* Helmet for SEO */}
    <Helmet>
        <title>{homeContent.home_title || 'Startup Business Partners - Home'}</title>
      </Helmet>
      {/* Navbar */}
      <Navbar />

      {/* Hero Banner */}
      <section className="hero-banner">
        <SliderHome slides={slides} />
      </section>

      {/* About Us Section */}
      <section className="about-section py-5">
        <Container>
          <Row>
            <Col md={6}>
              <h3>Inspiring Success With  <br /><span>Innovative Solutions</span></h3>
       <p>
        {homeContent.home_about || ' Many  '}</p>
        
          </Col>
            <Col md={6}>
              <img 
                src="/images/home-about.jpg" 
                alt="About our platform" 
                className="img-fluid rounded"
                style={{width:'100%;'}}
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* User Types Section */}
      <UserTypes />

      {/* Dynamic Content Sections */}
     <QuoteSection homeContent={homeContent} />
      <Testimonials testimonial={testimonial} />
          {/* <Teammembers videos={videos} /> */}
                  <section className="py-24">
      <div className="mb-16 text-center">
        <h1 className="text-4xl font-bold">Our Team</h1>
      </div>

 <div className="container mx-auto px-4 bg-white shadow-lg rounded-lg p-6">
        <TeamMember /> {/* Remove teams prop since it's fetched internally */}
      </div>
    </section>
      
      
     
      <BlogSection blogs={blogs} />
 <Newsletter />


      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Home;